import comp from "./TickComponent";
export default comp;
